import React from 'react';
import {Col, Container, Table} from 'react-bootstrap';
import {httpClient} from "../../service";
import {ActionResult, HttpMethod} from "../../model";
import {useAsync} from "react-async";
import LoadingHtml from "../../shared/Loading";
import ErrorPage from "../../shared/ErrorPage";
import {CouponJson} from "../../model/coupons/CouponJson";
import {Link} from 'react-router-dom';
import {getSessionCustNo} from './VerifyConfigModel';
import CouponVerifyUsedDetail from './CouponVerifyUsedDetail';

const CouponVerifyUsed = () => { // 추가
    let url = 'test/verifications/coupon/my';
    const custNo=getSessionCustNo();
    url +='/'+custNo;
    const options = {promiseFn: httpClient, method: HttpMethod.GET, url};
    const {data: act, error, isLoading} = useAsync<ActionResult>(options);
    if (isLoading) return <LoadingHtml/>;
    if (error) return <ErrorPage/>;
    if (!act) return null;
    if (!act.result) return <ErrorPage action={act}/>;
    const data: CouponJson[] = act.data;

    return (
        <>
            <div className="bloc l-bloc">
                <Container className="bloc-sm">
                    <div className="row mb-1">
                        <Col className="text-left col-sm-6">
                            <Link to="/verifications" className="btn btn-sm btn-primary">Home</Link>
                        </Col>
                        <Col className="text-right col-sm-6">
                            [<span className="text-primary">{custNo}</span>님]
                        </Col>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <Table striped bordered hover size="sm" variant="dark">
                                <colgroup>
                                    <col style={{width: '40px'}}/>
                                    <col style={{width: '70px'}}/>
                                    <col style={{width: '20%'}}/>
                                    <col style={{width: '10%'}}/>
                                    <col style={{width: '20%'}}/>
                                    <col style={{width: '90px'}}/>
                                    <col/>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th className="align-center">#</th>
                                    <th className="align-center">id</th>
                                    <th>발급쿠폰</th>
                                    <th className="align-center">유효기간</th>
                                    <th>쿠폰내용</th>
                                    <th className="align-center">검증</th>
                                    <th>사용내역</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    data.map((item, i) => {
                                        return <CouponVerifyUsedDetail item={item} key={i} index={i}/>
                                    })
                                }
                                </tbody>
                            </Table>
                        </div>

                    </div>
                </Container>
            </div>
        </>
    )
};

export default CouponVerifyUsed;
